/* @flow */
import AuthenticationView from 'auth/components/AuthenticationView.jsx';
import TextAppLink from 'user/components/TextAppLink.jsx';
import React from 'react';

class TextAppLinkPage extends React.Component {
  render() {
    return (
      <AuthenticationView {...this.props} size="large" className="TextAppLinkPage">
        <TextAppLink />
      </AuthenticationView>
    );
  }
}

export default TextAppLinkPage;



// WEBPACK FOOTER //
// ./src/user/components/TextAppLinkPage.jsx